export default {
  all: {
    id: 'listings_all',
    defaultMessage: 'All',
  },
  // grades
  gradesAll: {
    id: 'listings_state_all',
    defaultMessage: 'All grades',
  },
  gradeShiny: {
    id: 'grade_shiny',
    defaultMessage: 'Mint',
  },
  gradeGold: {
    id: 'grade_gold',
    defaultMessage: 'Very good',
  },
  gradeSilver: {
    id: 'grade_silver',
    defaultMessage: 'Good',
  },
  gradeBronze: {
    id: 'grade_bronze',
    defaultMessage: 'Fair',
  },
  gradeStallone: {
    id: 'grade_stallone',
    defaultMessage: 'Stallone',
  },

  // backbox
  backboxAll: {
    id: 'listings_buybox_all',
    defaultMessage: 'With and without buybox',
  },
  withBackbox: {
    id: 'listings_with_buybox',
    defaultMessage: 'With Buybox',
  },
  withoutBackbox: {
    id: 'listings_without_buybox',
    defaultMessage: 'Without Buybox',
  },

  // stock
  withAndWithoutStock: {
    id: 'listings_with_and_without_stock',
    defaultMessage: 'With and without stock',
  },
  withStock: {
    id: 'listings_with_stock',
    defaultMessage: 'With stock',
  },
  withoutStock: {
    id: 'listings_without_stock',
    defaultMessage: 'Without stock',
  },

  // alerts
  alertsAll: {
    id: 'listings_alerts_all',
    defaultMessage: 'All alerts',
  },
  priceAboveNew: {
    id: 'listings_price_above_new',
    defaultMessage: 'Price > New price',
  },

  // markets
  marketsAll: {
    id: 'listings_markets_all',
    defaultMessage: 'All markets',
  },

  // categories
  categoryAll: {
    id: 'listings_category_all',
    defaultMessage: 'All categories',
  },

  // battery type
  hasNewBatteryAll: {
    id: 'listings_battery_type_all',
    defaultMessage: 'All type',
  },
  hasNewBatteryNew: {
    id: 'listings_battery_type_new',
    defaultMessage: 'New',
  },
  hasNewBatteryRefurbished: {
    id: 'listings_battery_type_refurbished',
    defaultMessage: 'Refurbished',
  },
  // filters
  title: {
    id: 'listings_title_label',
    defaultMessage: 'Title',
  },
  sku: {
    id: 'listings_sku_label',
    defaultMessage: 'SKU',
  },
  uuid: {
    id: 'listings_uuid_label',
    defaultMessage: 'Uuid',
  },
  grade: {
    id: 'listings_grade_label',
    defaultMessage: 'Grade',
  },
  backbox: {
    id: 'listings_buybox_label',
    defaultMessage: 'Buybox',
  },
  stock: {
    id: 'listings_stock_label',
    defaultMessage: 'Stock',
  },
  alerts: {
    id: 'listings_alerts_label',
    defaultMessage: 'Alerts',
  },
  market: {
    id: 'listings_country_label',
    defaultMessage: 'Market',
  },
  submit: {
    id: 'listings_apply_filters',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'listings_reset_filters',
    defaultMessage: 'Reset',
  },
  showMoreFilters: {
    id: 'listings_show_more_filters',
    defaultMessage: 'Show more filters',
  },
  showLessFilters: {
    id: 'listings_show_less_filters',
    defaultMessage: 'Show less filters',
  },
  category: {
    id: 'listings_category_label',
    defaultMessage: 'Category',
  },
  hasNewBattery: {
    id: 'listings_category_battery_type',
    defaultMessage: 'Battery Type',
  },
  backmarketId: {
    id: 'listings_backmarket_id_label',
    defaultMessage: 'Back Market ID',
  },
  filter: {
    id: 'listings_mobile_filters_filter',
    defaultMessage: 'Filter',
  },
  viewResults: {
    id: 'listings_mobile_filters_view_results',
    defaultMessage: `View {hasFiltersSelected, select,
      true {filtered results}
      other {results}
    }`,
  },
} as const
